export const config = {
  headers: {
    "Content-Type": "multipart/form-data"
  }
}